<!--
 * @Author: zb
 * @LastEditors: l_hc
 * @Date: 2019-08-08 19:37:57
 * @LastEditTime: 2019-10-18 18:30:38
 * @Version: 1.0
 * @Description: 石化运输中运力信息的展示页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->
<template>
  <div class="transport-news">
    <div class="main-wrap">
      <select-condition ref="selectCondition" :config="config" @refresh="refresh">
        <template v-slot:transportDate="{ data, scope }">
          <div class="transport-data">
            <el-date-picker
              :ref="data.key[0]"
              v-model="scope[data.key[0]]"
              :editable="false"
              :picker-options="data.transportDateStartpickerOptions"
              :value-format="data.dateValueFormat"
              :format="data.dateValueFormat"
              type="date"
              align="right"
            />
            <div class="des">
              <span>-</span>
            </div>
            <el-date-picker
              :ref="data.key[1]"
              v-model="scope[data.key[1]]"
              :editable="false"
              :picker-options="data.transportDateEndpickerOptions"
              :value-format="data.dateValueFormat"
              :format="data.dateValueFormat"
              type="date"
              align="right"
            />
          </div>
        </template>
        <template v-slot:capacity="{data, scope}">
          <el-radio-group v-model="scope[data.key[0]]" @change="weightChange(scope,data,scope[data.key[0]])">
            <el-radio-button v-for="(i,index) of weight" :key="index" :label="i.value">
              {{ i.label }}
            </el-radio-button>
          </el-radio-group>
          <el-input v-model="scope[data.key[1]]" />
          <div class="des">
            <span>——</span>
          </div>
          <el-input v-model="scope[data.key[2]]" />
          <el-button class="el-button-ml" @click="changeCapacityWithCustom(scope)">确定</el-button>
        </template>
      </select-condition>
      <!--表格 -->
      <div v-loading="viewManager.loading" class="table-wrap">
        <transports-items
          :show-data.sync="resultData"
          @refreshPage="refreshPage"
          @favorites="favorites"
          @invitationBid="invitationBid"
          @transaction="transaction"
        />
      </div>

      <!-- 邀请报价  -->
      <invitation-offer
        v-if="invitationManager.visiable"
        :area="area"
        :data="invitationManager.data"
        @close="invitationManager.visiable = false"
      />

      <!-- 成交对话框  -->
      <offer-list
        v-if="transactionManager.visiable"
        :area="area"
        :data="transactionManager.data"
        @close="transactionManager.visiable = false"
      />
      <!-- 平台协议 -->
      <el-dialog :visible.sync="platform" width="600px" title="成交订单">
        <el-form ref="offerForm">
          <div class="con" v-html="platformTxt">
            <!--<p class="con-title">平台报价规则如下：</p>-->
            <!--<div class="con-box">-->
            <!--<p>1.权利人的姓名(名称)、联系方式、地址、身份证扫揎件(自然人)、企业法人营业执照(单位)、法定代表人身份证明(单位</p>-->
            <!--<p>2.要求删除或者断开链接的侵权作品的淮确名称和网络地址,以便干图网能够发现并初步审核涉嫌侵权作品。</p>-->
            <!--<p>3.认为构成侵权的初步证明材料,包括但不限于对作品享有版权或依法享有信息网络传播权的权属证明,以及涉嫌侵权作品侵权事实的举证。</p>-->
            <!--<p>4.通知书需由权利人或其合法授权人亲笔签名,若为单位则需加盖单位公章</p>-->
            <!--</div>-->
          </div>
          <el-checkbox v-model="checkedRule">我同意以上规则</el-checkbox>
          <el-checkbox v-model="checkedRemind">以后不再提醒</el-checkbox>
          <!--<el-checkbox v-model="checkedRule"></el-checkbox>-->
          <div class="form-line">
            <el-form-item>
              <el-button class="quotation-form-btn quotation-btn" :class="{'quotation-btn-xz': !checkedRule}" @click="nexStep">下一步</el-button>
            </el-form-item>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>

import transportsItems from '@/views/personal/transport/components/transportsItems'
import { getTransportList, findCmsPlatformProtocol, upateStatus } from '@/api/personal/find/transportManager'
import { Page } from '@/utils/commonDataModel'
import invitationOffer from './components/invitationOffer'
import offerList from './components/offerList'
import { conllection } from '@/api/cloud/storage-demand-info/storageDemandInfo'
import mixinsFunction from '@/utils/mixinsFunction'
import SelectCondition from './SelectCondition/SelectCondition'
const shortcuts = [
  {
    text: '今天',
    onClick(picker) {
      picker.$emit('pick', new Date())
    }
  },
  {
    text: '昨天',
    onClick(picker) {
      const date = new Date()
      date.setTime(date.getTime() - 3600 * 1000 * 24)
      picker.$emit('pick', date)
    }
  },
  {
    text: '一周前',
    onClick(picker) {
      const date = new Date()
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', date)
    }
  }
]

const validateNumber = (value) => {
  if (value.length > 15) {
    throw Error('长度最大为15')
  } else {
    const reg = /^[+]{0,1}[1-9]{1}(\d*)$|^[+]{0,1}(\d+\.\d+)$/
    if (reg.test(value) === false) {
      throw Error('请输入正确内容(正数、包括小数)')
    }
  }
}
export default {
  name: 'TransportNews',
  components: {
    'transports-items': transportsItems,
    'invitation-offer': invitationOffer,
    'offer-list': offerList,
    SelectCondition
  },
  mixins: [mixinsFunction],
  data() {
    return {
      // 平台规则弹窗状态
      platform: false,
      // 是否同意规则
      checkedRule: false,
      // 是否不再提示平台规则
      checkedRemind: false,
      platformTxt: '',
      quickFlag: false,
      invitationManager: {
        visiable: false,
        data: {}
      },
      transactionManager: {
        visiable: false,
        data: {}
      },
       isBtn: false,
      area: [],
      weight: [],
      transportType: [],
      goodType: [],
      // 列表数据
      resultData: {},
      pagination: new Page(),
      param: {},
      config: [
        {
          label: '起运地',
          key: 'startPlace',
          component: {
            type: 'cascader',
            data: () => this.area,
            showPath: true
          }
        },
        {
          label: '目的地',
          key: 'stopPlace',
          component: {
            type: 'cascader',
            data: () => this.area,
            showPath: true
          }
        },
        {
          label: '起运时间',
          key: ['startTransportDate', 'endTransportDate'],
          showLabel: function(item) {
            if (this.dataModal[item.key[0]] && this.dataModal[item.key[0]].toString() !== '' && this.dataModal[item.key[1]] && this.dataModal[item.key[1]].toString() !== '') {
              return {
                key: item.key.toString(),
                text: `${item.label}:${this.dataModal[item.key[0]]} 至 ${this.dataModal[item.key[1]]}`
              }
            }
          },
          dateValueFormat: 'yyyy-MM-dd',
          transportDateStartpickerOptions: {
            shortcuts: shortcuts,
            disabledDate: (time) => {
              if (this.$refs['selectCondition']) {
                const beginDateVal = this.$refs['selectCondition'].$data.dataModal.endTransportDate
                if (beginDateVal) {
                  return time.getTime() > Date.parse(beginDateVal)
                }
              }
            }
          },
          transportDateEndpickerOptions: {
            shortcuts: shortcuts,
            disabledDate: time => {
              if (this.$refs['selectCondition']) {
                const beginDateVal = this.$refs['selectCondition'].$data.dataModal.startTransportDate
                if (beginDateVal) {
                  return time.getTime() <= Date.parse(beginDateVal) - 1000 * 60 * 60 * 24
                }
              }
            }
          },
          component: {
            slot: 'transportDate'
          }
        },
        {
          label: '重量',
          key: ['capacityText', 'capacityTextStart', 'capacityTextEnd'],
          showLabel: function(item) {
            if (
              this.dataModal[item.key[0]] &&
              this.dataModal[item.key[0]] !== ''
            ) {
              const suit = item.component.data().filter(i => {
                return i.value == this.dataModal[item.key[0]]
              })
              if (suit && suit.length > 0) {
                return {
                  key: item.key,
                  text: `${item.label}:${suit[0].label}`
                }
              } else {
                return {
                  key: item.key,
                  text: `${item.label}:${this.dataModal[item.key[0]]}吨`
                }
              }
            }
          },
          class: { 'capacity-content': true },
          component: {
            type: 'cascader',
            slot: 'capacity',
            data: () => this.weight
          }
        },
        {
          label: '运输方式',
          key: 'transportType',
          showLabel: function(item) {
            if (this.dataModal[item.key] && this.dataModal[item.key] !== '') {
              const suit = item.component.data().filter(i => {
                return this.dataModal[item.key].indexOf(i.value) !== -1
              })
              if (suit && suit.length > 0) {
                return {
                  key: item.key,
                  text: `${item.label}:${suit.map(i => i.label).toString()}`
                }
              }
            }
          },
          component: {
            type: 'radio-group',
            data: () => this.transportType
          }
        }, {
          label: '运输品类',
          key: 'goodsType',
          default: [],
          showLabel: function(item) {
            if (this.dataModal[item.key] && this.dataModal[item.key] !== '') {
              const suit = item.component.data().filter(i => {
                return this.dataModal[item.key].indexOf(i.value) !== -1
              })
              if (suit && suit.length > 0) {
                return {
                  key: item.key,
                  text: `${item.label}:${suit.map(i => i.label).join('/')}`
                }
              }
            }
          },
          component: {
            type: 'checkbox-group',
            data: () => this.goodsType
          }
        }
      ]
    }
  },
  watch: {
    // 监测路由变化
    '$route': 'getQuick'
  },
  async created() {
    await Promise.all([
      this.getArea(),
      this.getGoodsType(),
      this.getTransportType(),
      this.getWeight()
    ]).then(data => {
      [
        this.area,
        this.goodsType,
        this.transportType,
        this.weight
      ] = data
    })
    // 判断是否有来自首页的快速查询,如果有,则不执行页面初始化的查询,执行快速查询
    if (JSON.stringify(this.$route.params)) {
      this.getQuick()
    }
  },
  methods: {
    refresh(data) {
      this.onSubmit(data)
    },
    getQuick() {
      // 判断是否有来自首页的快速查询,如果有,则不执行页面初始化的查询,执行快速查询
      if (this.$route.params.transportForm) {
        this.quickFlag = true
        if (this.$refs['selectCondition']) {
          this.$refs['selectCondition'].$data.dataModal.startPlace = this.$route.params.transportForm.startArea
          this.$refs['selectCondition'].$data.dataModal.stopPlace = this.$route.params.transportForm.stopArea
          if (this.$route.params.transportForm.capacity && this.$route.params.transportForm.capacity != '') {
            this.$refs['selectCondition'].$data.dataModal.capacityText = JSON.parse(this.$route.params.transportForm.capacity).value
          }
          if (this.$route.params.transportForm.type && this.$route.params.transportForm.type.length > 0) {
            this.$refs['selectCondition'].$data.dataModal.goodsType = JSON.parse(JSON.stringify(this.$route.params.transportForm.type)).map(item => JSON.parse(item).value)
          }
        }
      } else {
        this.initData()
      }
    },
    // 转换推荐参数
    exchangeData(data) {
      const handle = {
        get(target, key, proxy) {
          if (
            (key === 'startPlace' || key === 'stopPlace') &&
              target[key] &&
              target[key].length > 0
          ) {
            return ((target[key] instanceof Object) && target[key][0]) ? target[key].join('#') + '#' : target[key].toString()
          } else {
            return ''
          }
        }
      }
      const p = new Proxy(data, handle)
      const proxyData = Object.assign({}, p)
      return proxyData
    },
    // 修改分页触发表单提交
    refreshPage(data) {
      this.pagination.pageSize = data.pageSize
      this.pagination.pageNo = data.pageNo
      this.loadTableData(this.param)
    },
    loadTableData(params) {
      this.viewManager.loading = true
      getTransportList(this.pagination, params).then(data => {
        console.log(data)
        data.result.rows = data.result.rows.map(item => {
          item.hidden = true
          return item
        })
        this.resultData = data.result
      }).catch(error => {
        console.error(error)
      }).finally(() => {
        this.viewManager.loading = false
      })
    },
    // 页面初始化 获取初始数据
    initData() {
      this.loadTableData()
    },
    // 邀请报价,item为运力
    invitationBid(item) {
      console.log(item,'111111111111')
      //  经过资质认证的才可以邀请报价
      // this.isDetificate().then(() => {
      this.invitationManager.data = item
      this.invitationManager.visiable = true
      // })
    },
    // 成交弹窗
    transaction(item) {
      this.transactionManager.data = item
      const con = {
        type: 2,
        location: 1
      }
      findCmsPlatformProtocol(con).then(res => {
        console.log(res)
        if (res.result.length < 1) {
          this.transactionManager.visiable = true
        } else {
          this.platform = true
          this.platformTxt = res.result[0].content
        }
      })
    },
    // 平台协议下一步
    nexStep(data) {
      if (this.checkedRule) {
        let showIf = false
        if (this.checkedRule == true) {
          showIf = 0
        } else {
          showIf = 1
        }
        const con = {
          type: 2,
          location: 1,
          status: showIf
        }
        this.platform = false
        this.transactionManager.visiable = true
        upateStatus(con).then(res => {
          console.log(res)
        })
      } else {
        this.$message({
          message: '未同意以上规则！',
          type: 'warning'
        })
      }
    },
    // 收藏
    favorites(item) {
      // 请求未完成时重复点击
      if (item.collectionSubmit) {
        return false
      }
      item.collectionSubmit = true
      const favoritesFlag = item.favoritesFlag === '1' ? '2' : '1'
      // 发起收藏?取消收藏的请求
      conllection({
        id: item.collectionId,
        moduleId: item.id,
        moduleType: '2',
        collectionStatus: favoritesFlag
      }).then(data => {
        item.favoritesFlag = favoritesFlag
        item.collectionId = data.result.id
        this.$message({
          message: item.favoritesFlag == '1' ? '收藏成功' : '取消收藏成功',
          type: item.favoritesFlag == '1' ? 'success' : 'warning'
        })
        item.collectionSubmit = false
      }).catch(error => {
        item.collectionSubmit = false
      })
    },
    // 修改查询条件后触发查询
    onSubmit(data) {
      // 将查询条件绑定到页面的参数属性值上
      if (Object.prototype.toString.call(data.startPlace).indexOf('Array') !== -1 && data.startPlace.length > 0) {
        this.param.startPlace = data.startPlace.join('#')
      } else {
        this.param.startPlace = ''
      }
      if (Object.prototype.toString.call(data.stopPlace).indexOf('Array') !== -1 && data.stopPlace.length > 0) {
        this.param.stopPlace = data.stopPlace.join('#')
      } else {
        this.param.stopPlace = ''
      }

      this.param.minEarliestTime = data.startTransportDate
      this.param.maxEarliestTime = data.endTransportDate
      if (data.capacityTextStart && data.capacityTextEnd) {
        // this.param.minWeight = data.capacityTextStart
        // this.param.maxWeight = data.capacityTextEnd
        this.param.weightValue = data.capacityTextStart + ',' + data.capacityTextEnd
      } else {
        this.param.weightValue = data.capacityText.replace("-",",")
      }


      if (!this.isBtn&&this.param.weightValue.length>0) {
        console.log("isBtn："+this.isBtn)
        return;
      }
      if(data.capacityTextStart.length>0&&!this.isBtn){
        return;
        }
      this.isBtn=false
      this.param.goodsType = data.goodsType.toString()
      this.param.transportType = data.transportType
      this.loadTableData(this.param)
    },
    changeCapacityWithCustom(scope, data) {
      if (scope.capacityTextStart === '') {
        // scope.capacityTextStart = '1'
        this.$message({
          offset: 100,
          message: '请输入重量范围1!',
          type: 'warning'
        })
        return
      } else if (scope.capacityTextStart !== '0') {
        try {
          validateNumber(scope.capacityTextStart)
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.message,
            type: 'error'
          })
          scope.capacityTextStart = '1'
          scope.capacityTextEnd = '1'
          return
        }
      }
      if (scope.capacityTextEnd === '') {
        // scope.capacityTextEnd = '1'
        this.$message({
          offset: 100,
          message: '请输入重量范围1!',
          type: 'warning'
        })
        return
      } else if (scope.capacityTextEnd !== '0') {
        try {
          validateNumber(scope.capacityTextEnd)
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.message,
            type: 'error'
          })
          scope.capacityTextStart = '1'
          scope.capacityTextEnd = '1'
          return
        }
      }
      const capacity = scope.capacityTextStart + '-' + scope.capacityTextEnd
      this.isBtn=true
      // 触发watch
      scope.capacityText = capacity

    },
    weightChange(scope, data, label) {
      scope[data.key[1]] = ''
      scope[data.key[2]] = ''
      this.isBtn=true
      scope.capacityText = label
    }
  }
}
</script>

<style scoped lang='scss'>
  $main-color: #be2316;
  .transport-news {
    margin-bottom: 1rem;
  }

  /deep/ .main-wrap {
    margin-top: 1rem;

    .main {
      width: 1200px;
      margin: 0 auto 1rem;
      border: 1px solid rgba(229, 229, 229, 1);
      box-sizing: border-box;

      .el-form-item {
        padding-left: 20px;
        padding-right: 20px;

        .el-tag {
          margin-right: 1rem;
        }
      }

      .el-form {
        .selected-conditions {
          background-color: #F6F6F6;

          .el-form-item__content {
            display: flex;
            flex-wrap: wrap;

            .el-tag {
              margin-top: auto;
              margin-bottom: auto;
            }
          }

          .clear-conditions {
            cursor: pointer;
            color: #999999;
            align-items: flex-end;
            display: block;
            margin-left: auto;
          }
        }

        .capacity-content {
          .el-form-item__content {
            display: flex;
          }

          .el-input {
            margin-right: 1rem;
            width: 80px;
          }

          .des {
            margin-right: 1rem;
          }

          .el-button-ml {
            background-color: #BE2316;
            color: #ffffff;
          }
        }

        /*复选组样式 start*/
        .el-checkbox-button {
          margin-right: 1rem;
        }

        .el-checkbox-button:first-child .el-checkbox-button__inner {
          border-radius: 0 !important;
        }

        .el-checkbox-button:last-child .el-checkbox-button__inner {
          border-radius: 0 !important;
        }

        .el-checkbox-button.is-checked .el-checkbox-button__inner {
          background-color: #BE2316;
          border-color: #BE2316;
          color: #ffffff;
          box-shadow: -1px 0 0 0 #BE2316;
        }

        .el-checkbox-button__inner:hover {
          color: #BE2316;
        }

        .el-checkbox-button .el-checkbox-button__inner {
          border: none !important;
        }

        .el-checkbox-button.is-checked:first-child .el-checkbox-button__inner {
          border-left-color: #BE2316
        }

        /*复选组样式 end*/
        /*单选组样式 start*/
        .el-radio-button {
          margin-right: 1rem;
        }

        .el-radio-button:first-child .el-radio-button__inner {
          border-radius: 0 !important;
        }

        .el-radio-button:last-child .el-radio-button__inner {
          border-radius: 0 !important;
        }

        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          background-color: #BE2316;
          border-color: #BE2316;
          color: #ffffff;
          box-shadow: -1px 0 0 0 #BE2316;
        }

        .el-radio-button__inner:hover {
          color: #BE2316;
        }

        .el-radio-button .el-radio-button__inner {
          border: none !important;
        }

        .el-radio-button.is-checked:first-child .el-radio-button__inner {
          border-left-color: #BE2316
        }

        /*单选组样式 end*/
        .transport-data {
          display: flex;

          .el-input {
            margin-right: 1rem;
          }

          .des {
            margin-right: 1rem;
          }
        }

        .form-item {
          margin-right: 0;

          .form-item-btn {
            background: #BE2316;
            border: none;

            i {
              font-size: 14px;
              padding-right: 10px;
            }
          }
        }
      }
    }

    .content {
      position: relative;
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 50px;

      .content-img {
        width: 1200px;
      }

      .content-shoucang-tc {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -85px;
        margin-top: -35px;
      }

      .content-baojia {
        position: absolute;
        width: 50px;
        height: 100%;
        right: 0;
        top: 0;
      }

      .content-shoucang {
        position: absolute;
        width: 50px;
        height: 100%;
        right: 50px;
        top: 0;
      }
    }

    /*表格相关*/
    .table-wrap {
      width: 1200px;
      margin: 0 auto;
    }
  }
  .con{
    position: relative;
    margin-bottom: 10px;
    margin-top: 10px;
    padding: 5px 0px;
    padding-bottom: 15px;
    line-height: 30px;
    border-bottom: 1px solid #E3E3E3;
    .con-title{
      padding-bottom: 10px;
      color: #F92929;
    }
    .con-box{
      p{
        padding-bottom: 8px;
        line-height: 18px;
      }
    }
  }
  .quotation-btn{
    margin: 0 auto;
    display: block;
    margin-top: 20px;
    border-radius: 5px;
    background: #BF2317;
    color: #fff;
    &.quotation-btn-xz{
      background: #DE9189;
      color: #F2CCC3;
    }
  }

</style>
